import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/restricted/moment
import moment from 'moment';
import { N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { INTERVAL, ROLLUP, EXPLICIT, DATE_FORMAT_MOMENT } from '../../../../constants';
import type { DateType } from '../../../../types';
import { RollupIcon } from '../../../rollup-icon';
import { SprintIcon } from '../../../sprint-icon';

export type Props = {
	dateType: DateType;
	date?: number;
	intervalName?: string;
	caption: string;
	noDateMessage: string;
};

const DependencyCardDateLabel = ({
	dateType,
	date,
	intervalName,
	caption,
	noDateMessage,
}: Props) => {
	const label = date !== undefined ? moment.utc(date).format(DATE_FORMAT_MOMENT) : noDateMessage;

	const renderExplicitDate = () => (
		<Container data-testid="roadmap.timeline-table-kit.common.ui.dependency.card.date-label.explicit-date">
			{date !== undefined && `${caption} `}
			{label}
		</Container>
	);

	const renderIntervalDate = () => (
		<>
			{intervalName !== undefined && (
				<Container data-testid="roadmap.timeline-table-kit.common.ui.dependency.card.date-label.interval-date">
					<SprintIcon />
					{intervalName}
				</Container>
			)}
			{renderExplicitDate()}
		</>
	);

	const renderRollupDate = () => (
		<Container data-testid="roadmap.timeline-table-kit.common.ui.dependency.card.date-label.rollup-date">
			{date !== undefined && `${caption} `}
			<RollupIcon />
			{label}
		</Container>
	);

	switch (dateType) {
		case INTERVAL:
			return renderIntervalDate();

		case ROLLUP:
			return renderRollupDate();

		case EXPLICIT:
		default:
			return renderExplicitDate();
	}
};

export default DependencyCardDateLabel;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	paddingLeft: token('space.300', '24px'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '11px',
	color: token('color.text.subtlest', N200),
	display: 'flex',
});
